import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/medicalscales/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllMedicalScaleTypes: config.endpoints.backend + 'medicalscaletypes/getall',
        endpointGetAllSpecialties: config.endpoints.backend + 'entityspecialties/getall',
        endpointDelete: `${config.endpoints.backend}medicalscales/delete`,
        endpoint: config.endpoints.backend + 'medicalscales/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'pdc_medical_scale_type_id',
                type: 'select',
                label: 'Tipo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllMedicalScaleTypes,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'pdc_entity_specialty_id',
                type: 'select',
                label: 'Especialidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllSpecialties,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'reference_date',
                type: 'month',
                label: 'Referência',
                validations: {
                    required: false
                },
                columnSize: 2
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Escalas Médicas',
        labelTitleButtonAdd: 'Incluir nova Escala Médica',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'project',
                label: 'Projeto'
            },
            {
                name: 'type_specialty',
                label: 'Tipo - Especialidade'
            },
            {
                name: 'reference_date',
                label: 'Referência',
                width: '10%'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
